<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    single-line
    item-text="descricao"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:selection="item">
      <div class="truncate-text">
        <v-chip
          small
          v-if="item.item.codigoInterno"
          class="mr-2"
          label
        >
          {{ item.item.codigoInterno }}
        </v-chip>
        {{ item.item.descricao }}
      </div>
    </template>
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-chip
          small
          v-if="item.item.codigoInterno"
          class="mr-2"
          label
        >
          {{ item.item.codigoInterno }}
        </v-chip>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.item.descricao }}
          </v-list-item-title>
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CadastrosAdicionaisService from '@/api/cadastros-adicionais-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    type: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Cadastro adicional',
    },
    searchByStartOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value() {
      this.debounceSearch(null);
    },
  },
  methods: {
    buildStringSearchTerm(term, field) {
      if (this.searchByStartOnly) {
        return `${field} like "${term.toLowerCase()}%"`;
      }
      return `${field} like "%${term.toLowerCase()}%"`;
    },
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      const searchValue = isSelected || !val ? '' : val;
      const searchTerm = searchValue.toLowerCase();

      const query = `(${this.buildStringSearchTerm(searchTerm, 'descricao')} or ${this.buildStringSearchTerm(searchTerm, 'codigoInterno')}) and tipo = "${this.type}" order by descricao`;
      this.loading = true;
      CadastrosAdicionaisService.getCadastrosAdicionais({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
    this.debounceSearch();
  },
};
</script>
